import { connectHits } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'
import refreshAttribute from '../refreshAttribute'

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  if (hits.length !== 0) {
    widgetParams.container.innerHTML = '<ul class="row"></ul>'

    hits.forEach((hit) => {
      // create li element, add classes
      const li = document.createElement('li')
      li.classList.add('col-12')
      li.classList.add('md-col-6')
      li.classList.add('lg-col-4')
      li.classList.add('mb-6')
      li.classList.add('flex')

      li.innerHTML = `
      <div class="testimony-card">
        <div>
          <div class="testimony-card__top flex justify-between">
            ${hit.logo.singleMedia.publicId !== null
              ? `${hit.website !== undefined && hit.website !== null ? `<a href="${hit.website}" target="_blank" rel="noopener nofollow">` : ''}
                  <img class="testimony-img lazyload" data-src="https://res.cloudinary.com/oieau/image/upload/c_limit,h_93,q_auto,w_190/${hit.logo.singleMedia.publicId}" alt="${hit.logo.singleMedia.alt}"/>
                  ${hit.website !== undefined && hit.website !== null ? '</a>' : ''}
                `
              : `${hit.website !== undefined && hit.website !== null ? `<a href="${hit.website}" target="_blank" rel="noopener nofollow">` : ''}
                  <h3 class="small-title small-title--bold small-title--xs md:mt-6 block">${hit.title}</h3>
                  ${hit.website !== undefined && hit.website !== null ? '</a>' : ''}
                `
            }
            <div class="testimony-card__icon -mt-2 -mr-2">
              ${renderIcon(hit.testimonyType)}
            </div>
          </div>
          <div class="testimony-card__text mt-8">
            <svg width="24" height="20" class="testimony-icon testimony-icon--left">
                <use href="#icon-quote-left" xlink:href="#icon-quote-left"></use>
            </svg>
            <svg width="24" height="20" class="testimony-icon testimony-icon--right">
                <use href="#icon-quote-right" xlink:href="#icon-quote-right"></use>
            </svg>
            <div class="paragraph">
              ${hit.text}
            </div>
          </div>
          <div class="mt-4">
            <p class="text-dark-blue font-medium leading-5">${hit.name}</p>
            ${hit.personTitle !== undefined && hit.personTitle !== null
              ? `<p class="text-medium-grey text-15 tracking-tight2 leading-4 mt-1">${hit.personTitle}</p>`
              : ''
            }
            ${hit.job !== undefined && hit.job !== null
              ? `<p class="text-medium-grey text-15 tracking-tight2 leading-4 mt-1 ${hit.company !== undefined && hit.company !== null ? '' : 'mb-6'}">${hit.job}</p>`
              : ''
            }
            ${hit.company !== undefined && hit.company !== null
              ? `<p class="text-medium-grey text-15 tracking-tight2 leading-4 mt-1">${hit.company}</p>`
              : ''
            }
            ${hit.country !== undefined && hit.country !== null
              ? `<p class="text-medium-grey text-15 tracking-tight2 leading-4 mt-1 mb-6">${hit.country}</p>`
              : ''
            }
          </div>
        </div>
        <button onclick="_paq.push(['trackEvent', 'Click', 'En savoir +', '${hit.title}'])" class="cta cta--blue mt-6 self-start" js-dynamic-modal="{route: '/ajax/modal/testimony', id:'${hit.objectID}', model: 'testimony'}">${config.trads['testimony.more']}</button>
      </div>
      `

      get('ul', widgetParams.container).appendChild(li)

      refreshAttribute('js-dynamic-modal')(li.querySelector('[js-dynamic-modal]'))
    })
  } else {
    widgetParams.container.innerHTML = config.trads['list.testimony.empty']
  }
}

const renderIcon = (type) => {
  let icon = ''

  switch (type) {
    case 'text':
      icon = '<svg width="32" height="34" class="icon"><use href="#icon-temoignage" xlink:href="#icon-temoignage"></use></svg>'
      break
    case 'video':
      icon = '<svg width="40" height="28" class="icon"><use href="#icon-video" xlink:href="#icon-video"></use></svg>'
      break
    case 'audio':
      icon = '<svg width="24" height="38" class="icon"><use href="#icon-podcast" xlink:href="#icon-podcast"></use></svg>'
      break
  }

  return icon
}

const customHitsTestimony = connectHits(renderHits)

export default customHitsTestimony
